<template>
    <div class="uk-padding uk-margin-remove-top" >
        <div class="uk-container ">

            <h1 class="uk-text-left">
                <span class="half-a-border-on-top">Be an NCU Beacon</span>
            </h1>


            <div class="" uk-grid>
                <div class="uk-align-left">
                    <p class="uk-text-small">Unlock your potential by viewing the programmes in our colleges and school academic divisions.</p>
                </div>
                <div class="uk-align-right@m">
                    <router-link to="/alldepartments" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                       style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 10px; color: #033860; font-size: medium"
                    >See Academic Departments <span uk-icon="arrow-right"></span></router-link>
                </div>
            </div>
            <br>

            <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-3@l  " uk-grid>
                <div class="uk-align-center uk-padding-remove" style="padding: 3px !important; margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge test" style=" height: 350px; background-image: url('/bmh.jpg');">
                            <div class="uk-padding"  :class="{ active: 'hover3  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                 @mouseover="hover3 = true"
                                 @mouseleave="hover3 = false"
                            >
                                <div  v-if="!hover3" class="">
                                    <h4  style="color: rgba(255, 215, 3, 1); margin-top: 25%; text-align: center">College of Business and Management</h4>
                                    <!--<div >
                                        <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                    </div>-->
                                </div>
                                <div v-if="hover3" style="margin: -15px">
                                    <h5>College of Business & Hospitality Management</h5>
                                    <p class="uk-text-small">
                                        Welcome to the website of the College of Business and Management (CBM) at
                                        Northern Caribbean University. The College of Business and Management prides
                                        itself in preparing men and women based on Christian principles for positions in
                                        businesses and to nurture enterprising students to start their own businesses.
                                    </p>
                                    <router-link to="/college_bmh" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right uk-align-center uk-text-bold">View</router-link>
                                    <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                </div>
                                <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            --></div>
                        </div>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 3px !important;margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge test" style=" height: 350px; background-image: url('/cels.jpg');">
                            <div class="uk-padding"  :class="{ active: 'hover2  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                 @mouseover="hover2 = true"
                                 @mouseleave="hover2 = false"
                            >
                                <div  v-if="!hover2" class="">
                                    <h4  style="color: rgba(255, 215, 3, 1); margin-top: 25%; text-align: center">College of Education & Leadership</h4>
                                    <!--<div >
                                        <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                    </div>-->
                                </div>
                                <div v-if="hover2" style="margin: -15px">
                                    <h5>College of Education & Leadership</h5>
                                    <p class="uk-text-small">
                                        It is with utmost pleasure that I welcome you to the College of Education and
                                        Leadership at Northern Caribbean University. The College operates through two
                                        vibrant and dynamic departments – the Department of Graduate Education and
                                        Leadership and the Department of Teacher Education.
                                    </p>
                                    <br>
                                    <router-link to="/college_el" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right uk-align-center uk-text-bold">View</router-link>
                                    <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                </div>
                                <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            --></div>
                        </div>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove"  style="margin: 0px !important; padding: 3px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge test" style=" height: 350px; background-image: url('/hubbs.jpg');">
                            <div class="uk-padding"  :class="{ active: 'hover1  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                 @mouseover="hover1 = true"
                                 @mouseleave="hover1 = false"
                            >
                                <div  v-if="!hover1" class="">
                                    <h4  style="color: rgba(255, 215, 3, 1); margin-top: 25%; text-align: center">College of Humanities, Behavioural  and Social Sciences</h4>
                                    <!--<div >
                                        <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                    </div>-->
                                </div>
                                <div v-if="hover1" style="margin: -15px">
                                    <h5>College of Humanities, Behavioural  and Social Sciences</h5>
                                    <p class="uk-text-small">
                                        Welcome to the College of Humanities, Behavioural and Social Sciences (HUBSS);
                                        your college, your campus, and your home away from home. It is both an honour
                                        and a privilege to welcome you to this amazing family community and healthy productive learning environment.
                                    </p>
                                    <br>
                                    <router-link to="/college_hubbs" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right uk-align-center uk-text-bold">View</router-link>
                                    <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                </div>
                                <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            --></div>
                        </div>
                    </div>
                </div>

                <div class="uk-align-center " style="margin: 0px !important; padding: 3px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge  " >
                        <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge test" style=" height: 350px; background-image: url('/cnas1.jpg');">
                            <div class="uk-padding"  :class="{ active: 'hover  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                 @mouseover="hover = true"
                                 @mouseleave="hover = false"
                            >
                                <div  v-if="!hover" class="">
                                    <h4  style="color: rgba(255, 215, 3, 1); margin-top: 25%; text-align: center">College of Natural & Applied Sciences, Allied Health & Nursing</h4>
                                    <!--<div >
                                        <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                    </div>-->
                                </div>
                                <div v-if="hover" style="margin: -15px">
                                    <h5>College of Natural & Applied Sciences, Allied Health & Nursing </h5>
                                    <p class="uk-text-small">
                                        It is my pleasure to welcome you to the NCU College of Natural and Applied Sciences,
                                        Allied Health and Nursing! This super-college comprises seven departments: Biology,
                                        Chemistry and Environmental Sciences; Mathematics and Engineering; Computer and
                                        Information Sciences; Medical Technology; Dental Hygiene; Dietetics and Nutrition; and Nursing.
                                    </p>
                                    <router-link to="/college_cnasahn" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right uk-align-center uk-text-bold">View</router-link>
                                    <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                </div>
                                <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            --></div>
                        </div>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 3px !important; margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge test" style="height:350px;background-image: url('/srt.jpg');">
                            <div class="uk-padding"  :class="{ active: 'hover4  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                 @mouseover="hover4 = true"
                                 @mouseleave="hover4 = false"
                            >
                                <div  v-if="!hover4" class="">
                                    <h4  style="color: rgba(255, 215, 3, 1); margin-top: 25%; text-align: center">School of Religion & Theology</h4>
                                    <!--<div >
                                        <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                    </div>-->
                                </div>
                                <div v-if="hover4" style="margin: -15px">
                                    <h5>School of Religion & Theology</h5>
                                    <p class="uk-text-small">
                                        The School of Religion and Theology envisions itself as a major player in the
                                        “education and training of Pastor, Evangelists, Bible Workers, church leaders…”
                                        for the Seventh-day Adventist Church in Jamaica, the Caribbean region, and the world at large.
                                    </p>
                                    <br>
                                    <router-link to="/college_srt" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right uk-align-center uk-text-bold" >View</router-link>
                                    <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                </div>
                                <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            --></div>
                        </div>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 3px !important; margin: 0px !important;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "colleges",
        data() {
            return {
                hover: false,
                hover1: false,
                hover2: false,
                hover3: false,
                hover4: false,
            };
        }
    }
</script>

<style scoped>

    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        right:0;
        top:-2px;
    }
    .active {
        background-color: rgba(11, 11, 11,0.6) !important;

        transition: 1.0s;
        opacity: 1
    }
    .active:hover{
        opacity: 1;
        background-color: rgba(3, 56, 96,1) !important;
    }
    .active h4, .active button{
        color: #c0c0c0 !important;
        font-weight: bold;
    }
    .smoothEdge{
        border-radius: 5px;
    }
    @media screen and (max-width:768px){
      .uk-card{

        margin-left: 10% !important;
        display: block;
      }

    } @media screen and (max-width:600px){
      .uk-card{

        margin-left: 15% !important;
        display: block;
      }

        h1{
            font-size: 1.8em !important;
        }
        p{
            font-size: 0.7em !important;
        }
        .test{
            height: 230px !important;
        }
        h4{
            font-size: 1.1em !important;
        }

    }

</style>
